import React, { useState, useEffect } from 'react';
import { Chip, Snackbar } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import Cookies from 'js-cookie';

interface ViewTrackerProps {
  contentId: string;
  url: string;
  onViewSuccess: () => void;
}

const ViewTracker: React.FC<ViewTrackerProps> = ({ contentId, url, onViewSuccess }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarAnchor, setSnackbarAnchor] = useState({ vertical: 'bottom', horizontal: 'right' });

  const handleAction = async () => {
    const isAuthenticated = !!Cookies.get('token');
    if (!isAuthenticated) return;

    try {
      await fetch(`${process.env.REACT_APP_API_URL}/v1/content/addview`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('token')}`
        },
        body: JSON.stringify({ id: contentId })
      });
      onViewSuccess();
    } catch (error) {
      console.error('Failed to increment view:', error);
    }
  };

  const handleLeftClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    await handleAction();
    window.open(url, '_blank');
  };

  // Handle middle mouse (auxiliary) click
  const handleAuxClick = async (e: React.MouseEvent) => {
    if (e.button === 1) {
      await handleAction();
    }
  };

  // Handle right-click: show a Snackbar
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setSnackbarOpen(true);
  };

  // Dynamically set the Snackbar anchor based on window width
  useEffect(() => {
    const updateAnchor = () => {
      if (window.innerWidth < 400) {
        setSnackbarAnchor({ vertical: 'bottom', horizontal: 'left' });
      } else {
        setSnackbarAnchor({ vertical: 'bottom', horizontal: 'right' });
      }
    };
    updateAnchor();
    window.addEventListener('resize', updateAnchor);
    return () => window.removeEventListener('resize', updateAnchor);
  }, []);

  return (
    <>
      <Chip
        icon={<LinkIcon />}
        label={url?.length > 20 ? `${url.slice(0, 20)}...` : url}
        component="a"
        href={url}
        target="_blank"
        clickable
        onClick={handleLeftClick}
        onAuxClick={handleAuxClick}
        onContextMenu={handleContextMenu}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="If you want to open in a new tab, please use the middle mouse button."
        anchorOrigin={snackbarAnchor}
      />
    </>
  );
};

export default ViewTracker;
